var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 13,
    viewBox: "0 0 29 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0713 12.3996C13.9607 12.8798 15.0322 12.8798 15.9216 12.3996L26.9992 6.41928C29.4084 5.11867 28.888 1.74746 26.6116 0.950211C26.3927 1.20065 26.1207 1.42478 25.7925 1.6104L15.9733 7.16384C15.0569 7.68211 13.936 7.68211 13.0196 7.16383L3.20037 1.6104C2.87217 1.42478 2.60022 1.20065 2.38129 0.95021C0.104946 1.74745 -0.415471 5.11867 1.9937 6.41929L13.0713 12.3996Z",
    fill: "#D9D9D9",
    fillOpacity: 0.38
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtract);
export default __webpack_public_path__ + "static/media/Subtract.313e043b12df8c7811f82f09dd91b296.svg";
export { ForwardRef as ReactComponent };